(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artwork-upload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('apex-artwork-upload')) {
    customElements.define('apex-artwork-upload', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const input = this.querySelector('input[type="file"]');
        const filename = this.querySelector('input[type="hidden"]');
        const remove = this.querySelector('button');
        const error = this.querySelector('[role="alert"]');
        const update = () => {
          const file = input.files[0];
          let message = '';
          if (file && !/\.(ai|eps|svg|pdf)$/i.test(file.name)) message = this.dataset.typeError;
          else if (file && file.size > 20 * 1024 * 1024) message = this.dataset.sizeError;
          else if (file && file.size === 0) message = this.dataset.typeError;
          input.setCustomValidity(message);
          input.setAttribute('aria-invalid', String(Boolean(message)));
          error.textContent = message;
          error.hidden = !message;
          filename.value = file && !message ? file.name : '';
          filename.disabled = !file || Boolean(message);
          remove.hidden = !file;
          this.toggleAttribute('data-selected', Boolean(file));
        };
        input.addEventListener('change', update);
        remove.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
